const bindFooterEvent = ()=>{
      const footer__content = document.querySelector('.footer__content');
    // const imgMinus = document.querySelector('.content__box .item__extend dt img.minus');
    // const appDd = document.querySelector('.content__box .footer__content__item .item__app dd');

    footer__content.addEventListener('click', function(event) {
        // 检查是否点击的是 .plus 元素
        if (event.target.classList.contains('plus')) {
            const plus = event.target;
            const minus = plus.nextElementSibling; // 假设 .minus 是紧邻的兄弟元素
            const parent = plus.parentElement;     // dt 元素
            const siblingDd = parent.nextElementSibling; // 下一个兄弟元素 dd
            // console.log('==============');

            // 修改样式
            plus.style.display = 'none';
            if (minus && minus.classList.contains('minus')) {
                minus.style.display = 'inline';
            }

            if (siblingDd && siblingDd.tagName.toLowerCase() === 'dd') {
                siblingDd.style.display = 'flex'; // 或 block 根据需求
            }
        }
        if (event.target.classList.contains('minus')) {
            const minus = event.target;
            const plus = minus.previousElementSibling; // 假设 .minus 是紧邻的兄弟元素
            const parent = minus.parentElement;     // dt 元素
            const siblingDd = parent.nextElementSibling; // 下一个兄弟元素 dd
            // console.log('==============');

            // 修改样式
            minus.style.display = 'none';
            if (plus && plus.classList.contains('plus')) {
                plus.style.display = 'inline';
            }

            if (siblingDd && siblingDd.tagName.toLowerCase() === 'dd') {
                siblingDd.style.display = 'none'; // 或 block 根据需求
            }
        }
    });

}
const renderFooter = ()=>{
    const footer = document.querySelector('.footer');
    let footerHtml = 
    `
         <div class="footer__content">
        <div class="content__box">
            <div class="footer__content__item">
                <div class="item__logo">
                    <img src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-brand_of_aidot.svg?v=1759976383" alt="">
                </div>
                <div class="item__share">
                    <a href="https://www.facebook.com/linkind.lights/"><img src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-facebook.svg?v=1768821224" alt=""></a>
                    <a href="https://www.youtube.com/@linkindofficial"><img src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-youtube.svg?v=1768821224" alt=""></a>
                    <a href="https://www.instagram.com/linkindofficial/"><img src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-instagram.svg?v=1768821224" alt=""></a>
                    <a href="https://www.tiktok.com/@linkind_official?lang=en"><img src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-tiktok.svg?v=1768821224" alt=""></a>
                </div>
                <div class="item__app">
                    <dt style="cursor: default;">Download AiDot App
                        <img class="plus" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-icon_plus.svg?v=1759977598" alt="">
                        <img class="minus" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-icon_minus.svg?v=1759977544" alt=""></dt>
                    <dd>
                        <img class="qrcode" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-qrcode.jpg?v=1759977536" alt="">
                        <div class="google__apple">
                            <a href="https://play.google.com/store/apps/details?id=com.iotsolution.aidot"><img src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-google.svg?v=1759977527" alt=""></a>
                            <a href="https://apps.apple.com/us/app/aidot/id1580685276"><img src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-apple.svg?v=1759977518" alt=""></a>
                        </div>
                    </dd>
                </div>
            </div>
            <div class="footer__content__item item__extend">
                <dt>Company
                    <img class="plus" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-icon_plus.svg?v=1759977598" alt="">
                    <img class="minus" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-icon_minus.svg?v=1759977544" alt=""></dt>
                <dd>
                    <a href="/about-us">About Us</a>
                    <a href="/contact-us">Contact</a>
                    <a href="https://linkind.com/blogs/all">Blog</a>
                    <a href="/pages/ces2026">CES 2026</a>
                </dd>
            </div>
            <div class="footer__content__item item__extend">
                <dt>Products
                    <img class="plus" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-icon_plus.svg?v=1759977598" alt="">
                    <img class="minus" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-icon_minus.svg?v=1759977544" alt=""></dt>
                <dd>
                    <a href="/collections/led-light-bulbs">LED Light Bulbs</a>
                    <a href="/collections/spotlights">Spotlights</a>
                    <a href="/collections/pathway-lights">Pathway Lights</a>
                    <a href="/collections/tv-backlights">TV Backlights</a>
                    <a href="/collections/panel-lights">Panel Lights</a>
                    <a href="/collections/aidot-enabled">AiDot Enabled</a>
                    <a href="/collections/pool-lights">Pool & Wall Lights</a>
                    <a href="/collections/smart-accessories">Smart Accessories</a>
                    <a href="/collections/products">All Products</a>
                </dd>
            </div>
            <div class="footer__content__item item__extend">
                <dt>Support
                    <img class="plus" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-icon_plus.svg?v=1759977598" alt="">
                    <img class="minus" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-icon_minus.svg?v=1759977544" alt=""></dt>
                <dd>
                    <!-- <a href="/">Product Support</a> -->
                    <a href="/privacy-policy">Privacy Policy</a>
                    <a href="/terms-and-conditions">Terms &amp; Conditions</a>
                    <a href="/warranty">Warranty Policy</a>
                    <a href="/pages/shipping-policy">Shipping Policy</a>
                    <a href="/pages/refund-returns">Return Policy</a>
                    <a href="/pages/wholesale">Wholesale</a>
                    <a href="javascript:void(0);" onclick="__showCookieManageModal__" class="cookie-moadl-btn">Do Not Sell or Share My Personal Information</a>
                </dd>
            </div>
            <div class="footer__content__item item__extend">
                <dt>Contact Us
                    <img class="plus" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-icon_plus.svg?v=1759977598" alt="">
                    <img class="minus" src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-icon_minus.svg?v=1759977544" alt=""></dt>
                <dd>
                    <div class="contact">
                        <div><img src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-Icon_Footer_Email.svg?v=1759977753" alt=""></div>
                        <p><a href="mailto:support@linkind.com">support@linkind.com</a></p>
                    </div>
                    <div class="contact">
                        <div><img src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-Icon_Footer_Phone.svg?v=1759977744" alt=""></div>
                        <p>1(877) 770-5727</p>
                    </div>
                    <div class="contact">
                        <div><img src="https://cdn.shopify.com/s/files/1/0789/9906/0720/files/common-footer-Icon_Footer_Address.svg?v=1759977736" alt=""></div>
                        <p> 300 Technology CT SE Suite 100, Smyrna, GA, 30082, USA</p>
                    </div>
                </dd>
            </div>
        </div>
    </div>

    <div class="footer__copyright">
        <div class="copyright__box container">
             <p style="text-align: center;">Copyright © 2026 AIDOT TECHNOLOGY INC. All Rights Reserved</p>
            <!--
             <p><a href="/terms-and-conditions">Terms &amp; Conditions</a></p>
            <p><a href="/privacy-policy">Privacy Policy</a></p>
            <p><a href="/refund-returns">Return Policy</a></p>
            <p><a href="/warranty">Warranty Policy</a></p>
            <p><a href="/pages/shipping-policy">Shipping Policy</a></p>
            <p><a href="/pages/refund-returns">Return Policy</a></p>
            <p><a href="/pages/wholesale">Wholesale</a></p>-->
        </div>
    </div>
    `
    footer.innerHTML = footerHtml
}

const footerInit = ()=>{
    renderFooter()
    bindFooterEvent()
}
footerInit()